import Decimal from 'decimal.js-light';

export function isBetCasheable(bet: any, betSlipSelection?: any) {
  if (bet.selection.ResultStatus) return false;

  if (betSlipSelection && bet.selection.Market.InPlay !== betSlipSelection.inPlay) return false;

  if (bet.selection.Market.InPlay) {
    if (
      !bet.selection.Market.CashOutEnabled ||
      bet.selection.Market.CashOutStatus !== 'Open' ||
      bet.selection.Market.TradingStatus !== 'Open' ||
      bet.selection.TradingStatus !== 'Trading'
    ) {
      return false;
    }
  } else {
    if (bet.selection.Market.CashOutStatus === 'Suspended') {
      return false;
    }
    if (
      bet.selection.Market.TradingStatus !== 'Open' ||
      bet.selection.TradingStatus !== 'Trading'
    ) {
      return false;
    }
  }

  return true;
}

export function getIsBetCasheableFlag(bet: any) {
  if (bet.selection.ResultStatus) return '-';

  if (bet.selection.Market.InPlay) {
    if (!bet.selection.Market.CashOutEnabled) return '⦻';
    if (bet.selection.Market.CashOutStatus !== 'Open') return '×';
    if (bet.selection.Market.TradingStatus !== 'Open') return 'M';
    if (bet.selection.TradingStatus !== 'Trading') return 'S';
  } else {
    if (bet.selection.Market.CashOutStatus === 'Suspended') return '×';
    if (bet.selection.Market.TradingStatus !== 'Open') return 'M';
    if (bet.selection.TradingStatus !== 'Trading') return 'S';
  }

  return '+';
}

export function getIsBetCasheableColoredFlag(bet: any) {
  const c = (c: string, s: string) => `<span class="text-${c}-500">${s}</span>`;

  if (bet.selection.ResultStatus) return c('gray', '-');

  if (bet.selection.Market.InPlay) {
    if (!bet.selection.Market.CashOutEnabled) return c('red', '⦻');
    if (bet.selection.Market.CashOutStatus !== 'Open') return c('red', '×');
    if (bet.selection.Market.TradingStatus !== 'Open') return c('red', 'M');
    if (bet.selection.TradingStatus !== 'Trading') return c('red', 'S');
  } else {
    if (bet.selection.Market.CashOutStatus === 'Suspended') return c('red', '×');
    if (bet.selection.Market.TradingStatus !== 'Open') return c('red', 'M');
    if (bet.selection.TradingStatus !== 'Trading') return c('red', 'S');
  }

  return c('green', '+');
}

export function calculateCashOutMultiplier(bets: any[]) {
  let totalOdds = new Decimal(1);

  for (const bet of bets) {
    let odds = new Decimal(bet.odds);

    switch (bet.selection.ResultStatus) {
      case 'Winner':
        break;

      case 'Loser':
        odds = new Decimal(0);
        break;

      case 'Pushed':
        odds = new Decimal(1);
        break;

      case 'Placed':
        odds = odds.div(bet.selection.AdditionalResultData.countInPlace);
        break;

      case 'Partial':
        const winPart = new Decimal(bet.selection.AdditionalResultData.PercentageWin)
          .div(100)
          .mul(odds);
        const pushPart = new Decimal(bet.selection.AdditionalResultData.PercentagePush).div(100);
        odds = winPart.plus(pushPart);
        break;

      case null:
        odds = odds.div(bet.selection.Decimal);
        break;
    }

    totalOdds = totalOdds.mul(odds);
  }

  return totalOdds;
}
